import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Verificar que estamos en el navegador y el documento está listo
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Evitar inicializar múltiples veces
    if (window.fbq) {
      return;
    }
    // Inicializar la función fbq
    const fbq: any = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    if (!window._fbq) {
      window._fbq = fbq;
    }
    window.fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Crear y agregar el script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Agregar el script al head
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Inicializar el pixel con tu ID
    window.fbq('init', '1374426524177378');
    // Track PageView
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-40">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1374426524177378&ev=PageView&noscript=1" alt="" data-id="element-41" />
    </noscript>;
}